import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import Spinner from 'react-bootstrap/Spinner';
import ListInvestingTeam from './ListInvestingTeam';
import ListInvestingTeamActions from "./ListInvestingTeamActions";
import ModalInvestingTeam from './ModalInvestingTeam';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

const InvestingTeam = ({ location }) => {
    const history = useHistory();
    let feasibility = location.state;

    const [openModal,setOpenModal] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [membersTeam, setMembersTeam] = React.useState([]);
    const [roles, setRoles] = React.useState([]);    

    const regresar = () => {
        let _url = "/clinical-studio/dashboard";
        history.push({
            pathname: process.env.PUBLIC_URL +_url,
            state: feasibility
        });
    }

    const listarEquipoInvestigacion = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}equipoinves/listar?id_estudio=${location.state.id_estudio}`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            console.log(data);
            setMembersTeam(data);
        }).catch(err => {
            setMembersTeam([]);
        });
    }

    const listarRoles = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}equipoinves/listar-roles`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            console.log(data);
            setRoles(data);
        }).catch(err => {
            setRoles([]);
        });
    }

    const MemberList = () => {
        return (
            <ListInvestingTeam 
            reactTableData={membersTeam}
            listarEquipoInvestigacion={listarEquipoInvestigacion}
            feasibility={feasibility}
            ReactTableActions={ListInvestingTeamActions}
            membersTeam={membersTeam}
            />
        );
    }

    React.useEffect(() => {
        listarEquipoInvestigacion();
        listarRoles();
    },[]);

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Equipo Investigador</h3>
                    <h3 className="page-title center-title subhead">{feasibility.nombre_tercero} ({feasibility.acronimo})</h3>
                    <Col md={2}>
                        <div className='top_info_buttons_hc'>
                            <div>
                                <Tooltip
                                    title="Regresar al Dashboard"
                                >
                                    <IconButton
                                        aria-label="upload picture"
                                        component="span"
                                        className='tooltip-top'
                                        onClick={() => {
                                            regresar();
                                        }}
                                    >
                                        <ArrowBackIcon style={{ color: '#153365' }} />
                                    </IconButton>
                                </Tooltip>
                                <span style={{ marginLeft: '0.25em' }}>Regresar al Dashboard</span>
                            </div>
                        </div>
                    </Col>
                </Col>
            </Row>
            <Card>
                <CardBody>
                    <div className="text-center">
                        <Button onClick={() => setOpenModal(true)} className="btn btn-primary btn-sm text-white">
                            Agregar Miembro
                        </Button>
                    </div>
                    <Row>
                        {isLoading == true ?
                            <div className="text-center">
                                <Spinner animation="border" variant="success" />
                            </div>
                            :
                            <MemberList/>
                        }
                        <Container>
                        </Container>
                    </Row>
                </CardBody>
            </Card>
            <ModalInvestingTeam 
            openModal={openModal} 
            closeModal={() => setOpenModal(false)} 
            feasibility={feasibility} 
            listarEquipoInvestigacion={listarEquipoInvestigacion}
            data_profesional={null}
            membersTeam={membersTeam}
            />
        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_investing_team', // a unique identifier for this form
})(InvestingTeam);